export const MONTHLY_TERM = 'monthly';
export const YEARLY_TERM = 'yearly';
